import "/__w/1/s/BotFramework-WebChat/packages/fluent-theme/src/components/telephoneKeypad/private/Button.module_built.css";
const classes = {"telephone-keypad__button__text":"wwTs9lq_telephone-keypad__button__text","telephone-keypad--horizontal":"wwTs9lq_telephone-keypad--horizontal","telephone-keypad__button__ruby":"wwTs9lq_telephone-keypad__button__ruby","telephone-keypad__button":"wwTs9lq_telephone-keypad__button"}
export default classes

const _telephone_keypad__button__text0 = classes["telephone-keypad__button__text"]
export { _telephone_keypad__button__text0 as "telephone-keypad__button__text" }

const _telephone_keypad__horizontal0 = classes["telephone-keypad--horizontal"]
export { _telephone_keypad__horizontal0 as "telephone-keypad--horizontal" }

const _telephone_keypad__button__ruby0 = classes["telephone-keypad__button__ruby"]
export { _telephone_keypad__button__ruby0 as "telephone-keypad__button__ruby" }

const _telephone_keypad__button0 = classes["telephone-keypad__button"]
export { _telephone_keypad__button0 as "telephone-keypad__button" }
